<template>
    <div>
        <loading :active.sync="is_loading" 
        :can-cancel="true" 
        :is-full-page="true"></loading>

        <Navbar />

        <div class="container-fluid">
            <div class="sidebar">
                <OperationSidebar />
            </div>

            <div class="main" id="main">
                <Breadcrumb :links="[
                    {url: '/dashboard', text:'Home'},
                    {url: '/operation/dashboard', text: 'Operasi'},
                    {url:'#', text: 'Import Data'}
                ]"/>

                <h2 class="mb-4">
                    <b>Import Data</b>
                </h2>

                <!-- FORM -->
                <form ref="form_upload" @submit.prevent="previewData">
                    <div class="card">
                        <div class="card-body">

                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group mb-3">
                                        <label class="mb-1">
                                            Jenis Data
                                        </label>
                                        <select class="form-control" v-model="selected_type" required>
                                            <option value=""> -- Pilih Jenis Data -- </option>
                                            <option value="djuanda">TMA Rencana Waduk Djuanda</option>
                                            <option value="djuanda_spktpa">TMA SPKTPA Waduk Djuanda</option>
                                            <option value="cirata">TMA Rencana Waduk Cirata</option>
                                            <option value="cirata_spktpa">TMA SPKTPA Waduk Cirata</option>
                                            <option value="saguling">TMA Rencana Waduk Saguling</option>
                                            <option value="saguling_spktpa">TMA SPKTPA Waduk Saguling</option>
                                            <option value="djuanda_realtime">Waduk Djuanda (Realtime)</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group mb-4">
                                        <label class="mb-1">
                                            File CSV
                                        </label>
                                        <input type="file" class="form-control" accept=".csv" @change="readFile" required>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <br>
                                    <button class="btn btn-primary" type="submit">
                                        <i class="fa fa-search"></i>
                                        Preview Data
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <!-- MODAL -->
            <b-modal
                id="data_modal"
                ref="data_modal"
                size="xl"
                title="Preview Data"
                :hide-footer="true">

                <div class="data-wrapper mb-3">

                    <table class="table table-bordered table-striped table-sm">
                        <tbody>
                            <tr v-for="(row, rowIndex) in previewRows" :key="'row-' + rowIndex">
                                <!-- ELLIPSIS -->
                                <template v-if="row[0] == '__ELLIPSIS__'">
                                    <td :colspan="headers.length" class="text-center fw-bold">
                                        ...
                                    </td>
                                </template>

                                <!-- NORMAL ROW -->
                                <template v-else>

                                    <td v-for="(col, colIndex) in row" :key="'col-' + rowIndex + '-' + colIndex">
                                        {{ col }}
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <div class="form-group">
                    <button class="btn btn-primary me-2" @click="save">
                        <i class="fa fa-save"></i>
                        Import
                    </button>

                    <button class="btn btn-danger" @click="$bvModal.hide('data_modal')">
                        <i class="fa fa-times"></i>
                        Batal
                    </button>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import Navbar from '../../components/Navbar.vue'
import Breadcrumb from '../../components/Breadcrumb.vue'
import OperationSidebar from '../../components/OperationSidebar.vue'
import Loading from 'vue-loading-overlay';

import * as CSV from 'csv-string'
import { BModal } from 'bootstrap-vue'

import axios from 'axios'

export default {
    name: "ImportSeriData",

    components: {
        Loading,
        Navbar,
        Breadcrumb,
        OperationSidebar,
        BModal
    },

    data(){
        return {
            is_loading: false,

            selected_type: '',
            rows: [],
            headers: [],
            file: null
        }
    },
    computed: {
        previewRows(){

            if(this.rows.length <= 100){
                return this.rows;
            }

            let firstRows = this.rows.slice(0, 50);
            let lastRows = this.rows.slice(this.rows.length - 50);

            return [
                ...firstRows,
                ['__ELLIPSIS__'],
                ...lastRows
            ];
        }
    },

    methods: {

        createFormData(data){
            let fd = new FormData();

            Object.keys(data).forEach(key => {
                fd.append(key, data[key]);
            });

            return fd;
        },

        readFile(ev){

            let files = ev.target.files;

            if(files.length > 0){

                let file = files[0];

                this.file = file;

                if(
                    file.type == 'text/csv' ||
                    file.name.toLowerCase().includes('.csv')
                ){

                    let reader = new FileReader();

                    reader.addEventListener('load', (e) => {
                        let data = e.target.result;
                        let parsed = CSV.parse(data);
                        this.rows = parsed;
                    });

                    reader.readAsBinaryString(file);

                }else{

                    this.$swal(
                        "Error",
                        "File yg dipilih bukan CSV. harap upload file berformat CSV",
                        "error"
                    );
                }
            }
        },

        previewData(){

            if(this.selected_type == ''){

                this.$swal(
                    "Error",
                    "Silahkan pilih jenis data",
                    "error"
                );

                return;
            }

            if(this.rows.length == 0){

                this.$swal(
                    "Error",
                    "Silahkan pilih file CSV terlebih dahulu",
                    "error"
                );

                return;
            }

            this.$refs['data_modal'].show();
        },

        save(){

            const user_id = localStorage.getItem('id');
            const user_name = localStorage.getItem('name');
            const token = localStorage.getItem('token');

            this.is_loading = true;

            let fd = this.createFormData({
                import_type: this.selected_type,
                rows: JSON.stringify(this.rows),
                user_id,
                user_name
            });

            axios.post(
                this.$endpoints.operasi + 'import-data-bendung?token=' + token,
                fd
            )
            .then(response => {

                this.is_loading = false;

                this.$refs['form_upload'].reset();

                this.rows = [];
                this.headers = [];
                this.selected_type = '';

                this.$refs['data_modal'].hide();

                this.$swal(
                    "Berhasil",
                    response.data.message,
                    "success"
                );
            })
            .catch(e => {

                this.is_loading = false;

                this.$refs['form_upload'].reset();

                this.$refs['data_modal'].hide();

                let errors = [];

                if(
                    e.response &&
                    e.response.data &&
                    Array.isArray(e.response.data)
                ){
                    errors = e.response.data;
                }

                this.$swal({
                    title: "Import Gagal",
                    html: errors.join("<br>"),
                    icon: "error",
                    width: "64em"
                });
            });
        }
    }
}
</script>

<style scoped>

.data-wrapper{
    height: 500px;
    overflow: auto;
}

.table{
    font-size: 12px;
}
</style>